import { AxiosError } from "axios";
import { FC } from "react";
import { Link } from "react-router-dom";
import { FormCard } from "src/components";
import { Button } from "src/components/ui/button";
import { usePublishedForms } from "src/hooks";

interface Props {
	formsRedirectBaseUrl:
		| "/observations/reports/form/"
		| "/observations/submissions/";
	category?: string;
}

const PublishedForms: FC<Props> = ({ formsRedirectBaseUrl, category }) => {
	const {
		data: publishedForms,
		isSuccess,
		isLoading,
		isError,
		error,
		hasNextPage,
		isFetchingNextPage,
		fetchNextPage
	} = usePublishedForms({ category, enabled: Boolean(category) });

	const forms = publishedForms
		? publishedForms?.pages.flatMap(({ results }) => results)
		: [];

	return (
		<>
			{isError && error && (
				<p data-testid="published-forms-errormsg">
					{(error as AxiosError).message}
				</p>
			)}

			{isLoading && (
				<div
					className="animate-spin rounded-full h-8 w-8 border-2 border-muted border-t-foreground"
					aria-label="Loading..."
					data-testid="published-forms-loading"
				/>
			)}

			{isSuccess && (
				<div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
					{forms.map((form) => (
						<Link to={`${formsRedirectBaseUrl}${form.id}`} key={form.uuid}>
							<FormCard key={form.uuid} {...form} showCardOptions={false} />
						</Link>
					))}
				</div>
			)}

			{isSuccess && forms.length === 0 && (
				<p aria-label="empty-data-msg">No forms created. </p>
			)}

			{hasNextPage && (
				<div className="flex items-center justify-center my-4">
					<Button onClick={() => fetchNextPage()} disabled={isFetchingNextPage}>
						{isFetchingNextPage ? "Loading..." : "Load more"}
					</Button>
				</div>
			)}
		</>
	);
};

export default PublishedForms;
